(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["who-buy-box"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__whoBuyBox) return;
  window.__whoBuyBox = true;

  function money(pence) {
    return '£' + (pence / 100).toFixed(2).replace(/\.00$/, '');
  }

  function sizeLabel(raw) {
    var r = String(raw || '').trim().toLowerCase().replace(/[\s-]/g, '');
    var map = { xsmall: 'XS', xs: 'XS', small: 'S', s: 'S', medium: 'M', m: 'M', large: 'L', l: 'L', xl: 'XL', xlarge: 'XL', xxl: 'XXL', '2xl': 'XXL', xxxl: '3XL', '3xl': '3XL' };
    return map[r] || String(raw).toUpperCase();
  }

  function openCart() {
    if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
    if (typeof window.upcartOpenCart === 'function') { try { window.upcartOpenCart(); return; } catch (e) {} }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function currentVariantId(pack) {
    var checked = document.querySelector('.SizeSwatch__Radio:checked');
    var variants = [];
    try { variants = JSON.parse(pack.querySelector('[data-pack-variants]').textContent); } catch (e) {}
    if (checked) {
      var hit = variants.filter(function (x) { return String(x.option1) === String(checked.value); })[0];
      if (hit) return hit.id;
    }
    var sel = document.querySelector('.ProductForm__Variants select, select[name="id"]');
    if (sel && sel.value) return parseInt(sel.value, 10);
    var avail = variants.filter(function (x) { return x.available; })[0];
    return avail ? avail.id : null;
  }

  function init() {
    var realBtn = document.querySelector('.ProductForm__AddToCart');
    var form = realBtn ? realBtn.closest('.ProductForm') : document.querySelector('.ProductForm');
    var buyButtons = realBtn ? (realBtn.closest('.ProductForm__BuyButtons') || realBtn.parentElement) : null;

    var bb = document.querySelector('[data-who-bb]');
    if (bb && form && !bb.hasAttribute('data-moved')) {
      form.insertAdjacentElement('afterend', bb);
      bb.setAttribute('data-moved', 'true');
    }

    var nativeDesc = document.querySelector('.ProductMeta__Description, .Product__Info .ProductMeta__Description, .Product__Info .Rte[class*="Description"]');
    if (nativeDesc) nativeDesc.style.display = 'none';

    var pack = document.querySelector('[data-who-pack]');
    var pick = document.querySelector('[data-who-pick]');
    if (pick && buyButtons && !pick.hasAttribute('data-moved')) {
      buyButtons.insertAdjacentElement('beforebegin', pick);
      pick.setAttribute('data-moved', 'true');
    }

    var sticky = document.querySelector('[data-who-sticky]');
    var stickyBtn = sticky ? sticky.querySelector('[data-who-sticky-btn]') : null;
    var stickyPrice = sticky ? sticky.querySelector('[data-who-sticky-price]') : null;
    var mode = '1';
    var picked = [];
    var pickPrices = {};
    var unit = pack ? parseInt(pack.getAttribute('data-unit'), 10) : 0;

    if (pack && pick) {
      var grid = pick.querySelector('[data-who-pick-grid]');
      var addBtn = pick.querySelector('[data-who-pick-add]');
      var countEl = pick.querySelector('[data-pick-count]');
      var totalEl = pick.querySelector('[data-pick-total]');

      fetch('/collections/' + pack.getAttribute('data-tee-collection') + '/products.json?limit=50')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var current = pack.getAttribute('data-current');
          var picks = (d.products || []).filter(function (p) {
            return p.handle !== current && p.variants.some(function (x) { return x.available; }) &&
              p.options && p.options.length === 1 && String(p.options[0].name).toLowerCase() === 'size';
          });
          grid.innerHTML = picks.map(function (p) {
            var img = p.images && p.images[0] ? p.images[0].src.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
            var sizes = p.variants.map(function (x) {
              pickPrices[x.id] = Math.round(parseFloat(x.price) * 100);
              return '<button type="button" class="who-pick__size" data-pick-size="' + x.id + '"' + (x.available ? '' : ' disabled') + ' aria-label="' + p.title + ' ' + x.title + '">' + sizeLabel(x.title) + '</button>';
            }).join('');
            return '<div class="who-pick__item" data-pick-item><img src="' + img + '" alt="' + p.title + '" loading="lazy" width="300" height="300"><div class="who-pick__name">' + p.title + '</div><div class="who-pick__sizes">' + sizes + '</div></div>';
          }).join('');
        });

      function packTotal() {
        var ids = [currentVariantId(pack)].concat(picked);
        var prices = ids.map(function (id) { return pickPrices[id] || unit; });
        if (prices.length < 3) return unit * 2;
        return prices.reduce(function (a, b) { return a + b; }, 0) - Math.min.apply(null, prices);
      }

      function refreshPick() {
        countEl.textContent = picked.length + ' of 2';
        var total = packTotal();
        totalEl.textContent = money(total);
        addBtn.disabled = picked.length < 2;
        if (stickyPrice && mode === '3') stickyPrice.textContent = money(total);
      }

      document.addEventListener('click', function (e) {
        var s = e.target.closest('[data-pick-size]');
        if (!s || s.disabled) return;
        var item = s.closest('[data-pick-item]');
        var id = s.getAttribute('data-pick-size');
        var prev = item.querySelector('[data-pick-size].is-selected');
        if (prev) { picked = picked.filter(function (x) { return x !== prev.getAttribute('data-pick-size'); }); prev.classList.remove('is-selected'); }
        if (prev === s) { item.classList.remove('is-picked'); refreshPick(); return; }
        if (picked.length >= 2) {
          var oldest = picked.shift();
          var ob = grid.querySelector('[data-pick-size="' + oldest + '"]');
          if (ob) { ob.classList.remove('is-selected'); ob.closest('[data-pick-item]').classList.remove('is-picked'); }
        }
        picked.push(id);
        s.classList.add('is-selected');
        item.classList.add('is-picked');
        refreshPick();
      });

      addBtn.addEventListener('click', function () {
        var mine = currentVariantId(pack);
        if (!mine) { if (realBtn) realBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        var items = [{ id: Number(mine), quantity: 1 }].concat(picked.map(function (id) { return { id: Number(id), quantity: 1 }; }));
        addBtn.disabled = true; addBtn.textContent = 'Adding';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () { addBtn.textContent = 'Added'; openCart(); })
          .catch(function () { addBtn.textContent = 'Try again'; })
          .finally(function () { setTimeout(function () { addBtn.disabled = picked.length < 2; addBtn.innerHTML = 'Add 3 to cart · <span data-pick-total>' + money(packTotal()) + '</span>'; totalEl = addBtn.querySelector('[data-pick-total]'); }, 1600); });
      });

      pack.addEventListener('change', function (e) {
        if (e.target.name !== 'who-pack') return;
        mode = e.target.value;
        pack.querySelectorAll('.who-pack__opt').forEach(function (o) { o.classList.toggle('is-selected', o.querySelector('input').checked); });
        var three = mode === '3';
        pick.hidden = !three;
        if (buyButtons) buyButtons.classList.toggle('who-pack-hide', three);
        if (stickyBtn) stickyBtn.textContent = three ? 'Add 3 to cart' : ((realBtn && realBtn.textContent.trim()) || 'Add to cart');
        if (three) refreshPick();
        else if (stickyPrice) stickyPrice.textContent = money(unit);
      });

      document.addEventListener('change', function (e) {
        if (e.target.classList && e.target.classList.contains('SizeSwatch__Radio') && mode === '3') refreshPick();
      });
    }

    if (!sticky || !realBtn) return;

    stickyBtn.addEventListener('click', function () {
      if (mode === '3' && pick) {
        var ab = pick.querySelector('[data-who-pick-add]');
        if (ab.disabled) pick.scrollIntoView({ behavior: 'smooth', block: 'center' }); else ab.click();
        return;
      }
      if (realBtn.disabled) { realBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      realBtn.click();
    });

    function syncLabel() {
      if (mode === '3') return;
      var t = (realBtn.textContent || '').trim();
      if (t) stickyBtn.textContent = t;
      stickyBtn.disabled = realBtn.disabled;
    }
    syncLabel();
    new MutationObserver(syncLabel).observe(realBtn, { childList: true, subtree: true, attributes: true });

    var pagePrice = document.querySelector('.ProductMeta__Price');
    if (stickyPrice && pagePrice) {
      new MutationObserver(function () { if (mode !== '3') stickyPrice.textContent = pagePrice.textContent.trim(); })
        .observe(pagePrice, { childList: true, subtree: true, characterData: true });
    }

    var sizeEl = sticky.querySelector('[data-who-sticky-size]');
    function syncSize() {
      var checked = document.querySelector('.SizeSwatch__Radio:checked');
      if (sizeEl) sizeEl.textContent = checked ? ' · ' + sizeLabel(checked.value) : '';
    }
    syncSize();
    document.addEventListener('change', function (e) { if (e.target.classList && e.target.classList.contains('SizeSwatch__Radio')) syncSize(); });

    if ('IntersectionObserver' in window) {
      var watch = form || realBtn;
      new IntersectionObserver(function (entries) {
        var onScreen = entries[0].isIntersecting;
        sticky.classList.toggle('is-visible', !onScreen);
        sticky.setAttribute('aria-hidden', onScreen ? 'true' : 'false');
      }, { threshold: 0 }).observe(watch);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["who-quick-add"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__whoQuickAdd) return;
  window.__whoQuickAdd = true;

  var LABEL = 'Quick add +';

  /* Who Crew cards: send image and title links to the landing page */
  function linkCrewCards(scope) {
    (scope || document).querySelectorAll('[data-who-crew]').forEach(function (box) {
      var url = box.getAttribute('data-who-crew');
      var card = box.closest('.ProductItem') || box.parentNode;
      if (!card) return;
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        a.setAttribute('href', url);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { linkCrewCards(); });
  } else {
    linkCrewCards();
  }

  /* Re-run when Prestige reloads the grid (filters, sorting, pagination) */
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; linkCrewCards(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function openCart() {
    if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
    if (typeof window.upcartOpenCart === 'function') { try { window.upcartOpenCart(); return; } catch (e) {} }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (!document.querySelector('upcart-root, #upCart, [id*="upcart" i]')) window.location.href = '/cart';
  }

  function reset(btn) {
    setTimeout(function () {
      btn.disabled = false;
      btn.textContent = LABEL;
    }, 1800);
  }

  document.addEventListener('click', function (e) {
    var size = e.target.closest('[data-who-size]');
    if (size && !size.disabled) {
      e.preventDefault();
      var box = size.closest('[data-who-qa]');
      box.querySelectorAll('[data-who-size]').forEach(function (b) { b.classList.remove('is-selected'); });
      size.classList.add('is-selected');
      box.setAttribute('data-variant', size.getAttribute('data-who-size'));
      var btn = box.querySelector('[data-who-add]');
      if (btn && !btn.disabled) btn.textContent = LABEL;
      return;
    }

    var add = e.target.closest('[data-who-add]');
    if (!add || add.disabled) return;
    e.preventDefault();

    var wrap = add.closest('[data-who-qa]');
    var id = wrap.getAttribute('data-variant');
    if (!id) {
      add.textContent = 'Select a size';
      add.classList.remove('is-prompt'); void add.offsetWidth; add.classList.add('is-prompt');
      return;
    }

    add.disabled = true;
    add.textContent = 'Adding';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      add.textContent = 'Added';
      openCart();
    }).catch(function () {
      add.textContent = 'Try again';
    }).finally(function () {
      reset(add);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
